// extracted by mini-css-extract-plugin
export default {"wrap":"RulesConfig_wrap__GlgdR"};